module.exports = __webpack_public_path__ + "img/74.71db1f84.png";